import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-ui-stepper',
  templateUrl: './ui-stepper.component.html',
  styleUrls: ['./ui-stepper.component.scss']
})
export class UiStepperComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
